import React, { FC } from 'react';
import Modal from '@components/Modal';
import Button from '@/components/DesignLibrary/Button';
import WarningCircle from '@/components/Icons/WarningCircle';
import XCircle from '@components/Icons/XCircle';
import Divider from '@/components/Divider';
import s from './EditInvoiceConfirmationModal.module.scss';

type Props = {
    onClose: ()=>void;
    onSubmit: ()=>void
};

const EditInvoiceConfirmationModal: FC<Props> = ({ onClose,onSubmit }) => (
  <Modal
    hasPadding
    onClose={onClose}
    closeIcon={<XCircle weight="fill" size={24} color="var(--color-gray-100)" />}
    title=""
  >
    <div className={s.modalContent}>
      <div className={s.modalHeader}>
        <WarningCircle size={96} weight="fill" color="var(--color-warning)" />
        <h2 className={s.modalHeaderTitle}>You are about to edit the invoice</h2>
      </div>
      <div className={s.modalBody}>
        <p className={s.modalBodyText}>
        A new invoice will be generated and designated as an edited version of the previous one.
        </p>
        <Divider className={s.modalBodyDivider} />

        <p className={[s.modalBodyText, s.modalTextWarning].join(' ')}>
        Glade is unable to automatically move or edit payment data to maintain a digital footprint of all activity.
        </p>

        <div className={s.modalBodyButtons}>
          <Button size='lg' className={s.modalBodyButton} variant='primary' onClick={() => onSubmit()}>Continue</Button>
          <Button size='lg' className={s.modalBodyButton} variant='secondary' onClick={() => onClose()}>Cancel</Button>
        </div>
      </div>
    </div>
  </Modal>
);

export default EditInvoiceConfirmationModal;